import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.mode)
    ? (_openBlock(), _createBlock(_component_q_btn_dropdown, _mergeProps({
        key: 0,
        label: _ctx.mode.label,
        title: _ctx.mode.label
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _createVNode(_component_q_list, { dense: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  key: mode.value,
                  active: _ctx.modelValue === mode.value,
                  clickable: "",
                  onClick: ($event: any) => (_ctx.change(mode.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mode.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["active", "onClick"])), [
                  [_directive_close_popup]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["label", "title"]))
    : _createCommentVNode("", true)
}